import React, { useState, useRef, useEffect } from "react";
import { Container, Grid, TextField, Box, Button, Typography } from "@mui/material";

import { imagePath } from "../../../utils/assetUtils";
import { useTranslation } from "react-i18next";
import OTPService from "../services/OTPService";
import { useNavigate, useLocation } from "react-router";
import { Link, useSearchParams } from "react-router-dom";
import { SnackbarAlert } from "../../common/SnackbarAlert";
import { snackbarActions } from "../../../redux/features/snackbar/snackbarSlice";
import SimpleReactValidator from "simple-react-validator";
import { ROUTES } from "../../../constants/routes";
import CONSTANTS from "../../../constants/constants";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { userActions } from "../../../redux/features/user/userSlice";
import ProfileService from "../../Profile/services/ProfileService";
import { commonActions } from "../../../redux/features/common/commonSlice";
import CommonButton from "../../common/Button";

const VerifiedOTP = (props: any) => {

    const { showSnackbar,handleLoader,login } = props;
    const location = useLocation();
    const isDemoUser = useAppSelector((state) => state.common.demoUser);
    const mfaResendEmail = useAppSelector(state => state.common.mfaResendEmail) || "";
    const dispatch = useAppDispatch();
    window.onpopstate = function (e: any) {
        if (window.location.href.includes(ROUTES.SEND_OTP)) {
            const responseMessage = t("verifyotp.are_you_sure_want_to_exit");
            const response = confirm(responseMessage);
            if (!response) {
                e.stopPropagation();
                window.history.forward();
            } else {
                navigate(ROUTES.INITIAL_PAGE);
            }
        }
    };

    {
    /* Language translate function*/
    }
    const [t, i18n] = useTranslation();
    {
    /* Language translate function*/
    }

    const navigate = useNavigate();

    const [otp, setOtp] = useState<any>();
    const [error, setError] = useState("");
    const [openSnackBar, setOpenSnackBar] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [successAlert, setSuccessAlert] = useState(false);
    const [fullWidthL, setFullWidthL] = useState<number>(0);
    const [otpFailError,setOtpFailError] =useState<any>("");
    const [isResendingOtp, setIsResendingOtp] = useState<boolean>(false);
    const email = location?.state?.email || mfaResendEmail || "";
    const isMfaRequired = location?.state?.email ? !!location?.state?.isMfaRequired : !!mfaResendEmail;

    // validation
    const [, forceUpdate] = useState(0);

    // eslint-disable-next-line no-control-regex
    const isSingleByte = (value: string) => { return /^[\x00-\xFF]*$/.test(value); };

    const validator = useRef(
        new SimpleReactValidator({
            autoForceUpdate: { forceUpdate },
            className: "text-danger",
            messages: {
                required: t("required.this_field_cannot_be_empty"),
            },
            validators: {
                SingleByteNumber: {
                    message: t("registerpage.single_byte_otp"),
                    rule: (value) => isSingleByte(value),
                },
            }
        })
    );

    useEffect(() => {
        forceUpdate(1);
    });
    //validation

    const handleOnBlur = (e: any) => {
        const { name } = e.target;
        validator.current.showMessageFor(name);
    };

    const handleChange = (e: any) => {
        setOtpFailError("");
        const { name, value } = e.target;
        name === "otp" ? setOtp(value) : null;
        validator.current.hideMessageFor(name);
    };
    useEffect(() => {
        if (!email) {
            navigate(ROUTES.INITIAL_PAGE);
        }
    }, [email]);

    const getUserDetails = async () => {
        const isHitDummyURL = false;
        await new ProfileService({}, isHitDummyURL)
            .sellerInfo()
            .then((res) => {
                dispatch(userActions.USER_DETAILS(res));
            })
            .catch((err) => {
                showSnackbar(err?.message, false);
            });
    };

    const handleSubmit = () => {
        if (validator.current.allValid()) {
            handleLoader(true);
            const payload = { email: email, otp: +otp };
            const isHitDummyURL = false;
            new OTPService(payload, isHitDummyURL)
                .verify(isDemoUser)
                .then((res) => {
                    handleLoader(false);
                    dispatch(commonActions.CLEAR_MFA_RESEND_EMAIL());
                    if (isMfaRequired) {
                        const { accessToken,name,email,userType,storeId,storeName,storeCode,perPageLimit } = res;
                        login(accessToken, true, userType, email, name, storeId, storeName, storeCode, perPageLimit);
                        if(userType!=CONSTANTS.USER_TYPE_EXHIBITOR){
                            getUserDetails();
                        }
                        navigate(ROUTES.OMS);
                        return;
                    }
                    navigate(ROUTES.CREATE_PASSWORD, {state: {email: email,isDemoUser: isDemoUser} });
                    showSnackbar(res, true);
                })
                .catch((err) => {
                    handleLoader(false);
                    err?.message == CONSTANTS.OTP_ERROR_MSG ?    
                        setOtpFailError(err?.message) :
                        showSnackbar(err?.message, false);
                });
        } else {
            validator.current.showMessages();
        }
    };

    const handleResendOtp = () => {
        if (isResendingOtp) {
            return;
        }
        setIsResendingOtp(true);
        handleLoader(true);
        const payload = { email, otpType: isMfaRequired ? CONSTANTS.OTP_MFA_TYPE : CONSTANTS.OTP_PASSWORD_TYPE };
        const isHitDummyURL = false;
        new OTPService(payload, isHitDummyURL)
            .generate(isDemoUser)
            .then((res) => {
                handleLoader(false);
                setIsResendingOtp(false);
                setOtpFailError("");
                showSnackbar(res, true);
            })
            .catch((err) => {
                handleLoader(false);
                setIsResendingOtp(false);
                showSnackbar(err?.message, false);
            });
    };

    const handleInputType = (e: any) => {
        e.target.value = e.target.value.replace(/[^0-9||０-９]/g, "");
    };

    return (
        <>
            {/* VerifiedOTP page starts here */}
            <Grid>
                <Container>
                    <Grid container spacing={4}>
                        {/* offset grid with column*/}
                        <Grid item xs={12} xl={4} lg={4} md={2} sm={12}></Grid>
                        {/* main grid column! */}
                        <Grid item xs={12} xl={4} lg={4} md={8} sm={12}>
                            <img
                                className="logo-img"
                                alt="cainz"
                                src={imagePath("logo-large.png")}
                            />
                            <Grid sx={{ mb: 2 }}>
                                <TextField
                                    label={t("verifyotp.enter_otp")}
                                    fullWidth
                                    variant="outlined"
                                    type="otp"
                                    name="otp"
                                    onChange={(e) => handleChange(e)}
                                    value={otp ?? ""}
                                    inputProps={{ maxLength: 4 }}
                                    onInput={(e) => handleInputType(e)}
                                    onBlur={(e) => handleOnBlur(e)}
                                />
                                {validator.current.message("otp", otp, ["required","SingleByteNumber"])}
                                {otpFailError!==""?
                                    <Typography  sx={{color:"red"}}>{otpFailError}</Typography>
                                    :""}
                                
                                <Grid item xs={12} md={12} sx={{ my: 2 }}>
                                    <Button fullWidth onClick={handleSubmit}>{isMfaRequired ? t("verifyotp.mfa_submit") : t("verifyotp.verify")}</Button>
                                </Grid>
                                <Link to={ROUTES.INITIAL_PAGE}>
                                    <Typography className="Order_id_link float_right">{t("sendotp.back_to_login")}</Typography>                           
                                </Link>
                                {isMfaRequired && (
                                    <Grid sx={{ mt: 6, textAlign: "center" }}>
                                        <CommonButton 
                                            route={window.location.pathname} 
                                            functionToExecute={handleResendOtp} 
                                            className="upload-btn" 
                                            btnName={isMfaRequired ? t("verifyotp.mfa_resend") : t("verifyotp.resend")}
                                            disableCondition={isResendingOtp}
                                        />
                                    </Grid>
                                )}


                            </Grid>
                        </Grid>
                        {/* offset grid with column*/}
                        <Grid item xs={12} xl={4} lg={4} md={2} sm={12}></Grid>
                    </Grid>
                </Container>
            </Grid>
            {/* VerifiedOTP page starts here */}
        </>
    );
};

export default VerifiedOTP;
